import React, { useEffect, useState } from 'react'

import { MaskBackgroundProps } from '../types'

/**
 * MaskBackground - Renders an SVG mask as background
 */
export const MaskBackground = React.memo(({ layerStyle, index, values }: MaskBackgroundProps) => {
  const [svgMask, setSvgMask] = useState<string | null>(null)
  const [maskId] = useState('mask-' + Math.random().toString(36).substring(2, 11))

  useEffect(() => {
    if (values?.type !== '#') {
      const fetchSvg = async () => {
        try {
          const response = await fetch(values?.type as string)
          let svgContent = await response.text()

          svgContent = svgContent
            .replace(/width="[^"]*"/g, '')
            .replace(/height="[^"]*"/g, '')
            .replace(/xmlns:xlink="[^"]*"/g, '')
            .replace(/<\?xml[^?]*\?>/g, '')
            .trim()
          setSvgMask(svgContent)
        } catch (error) {
          console.error('Error loading SVG mask:', error)
        }
      }

      fetchSvg()
    }
  }, [values?.type])

  if (!svgMask) return null

  const xpos = Array.isArray(values?.xpos) ? values?.xpos[0] : (values?.xpos ?? 50)
  const ypos = Array.isArray(values?.ypos) ? values?.ypos[0] : (values?.ypos ?? 50)
  const size = Array.isArray(values?.size) ? values?.size[0] : (values?.size ?? 50)
  const rotate = values?.rotate ?? 0

  const translateX = (xpos - 50) * 10
  const translateY = (ypos - 50) * 10

  return (
    <div style={{ ...layerStyle, zIndex: -index - 1 }}>
      <svg className='absolute inset-0 w-full h-full' viewBox='0 0 1000 1000' preserveAspectRatio='xMidYMid slice'>
        <defs>
          <mask id={maskId}>
            <rect width='1000' height='1000' fill={values?.inverted ? 'white' : 'black'} />
            <g
              transform={`
                    translate(500 500)
                    translate(${translateX} ${translateY})
                    rotate(${rotate})
                    scale(${size / 50})
                    translate(-500 -500)
                  `}
            >
              <g
                dangerouslySetInnerHTML={{
                  __html: svgMask
                    .replace(/fill="[^"]*"/g, `fill="${values?.inverted ? 'black' : 'white'}"`)
                    .replace(/stroke="[^"]*"/g, `stroke="${values?.inverted ? 'black' : 'white'}"`)
                    .replace(/<style>[^<]*<\/style>/g, ''),
                }}
              />
            </g>
          </mask>
        </defs>
        <rect width='1000' height='1000' fill='currentColor' opacity={values?.opacity ?? 1} mask={`url(#${maskId})`} />
      </svg>
    </div>
  )
})
MaskBackground.displayName = 'MaskBackground'
